import ApplicationConf from 'conf/ApplicationConf'
import { aquaFetch } from 'common/utils/ActionUtils'
import { toast } from 'react-toastify'

const call = async (url, options, errorMessage) => {
    try {
        return await aquaFetch(url, options)
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err)
        toast.error(errorMessage)
    }
}

const callWithSuccessToast = async (url, options, errorMessage, successMessage) => {
    const response = await call(url, options, errorMessage)
    if (response) {
        toast.success(successMessage)
    }
    return response
}

// Lots DEV Aquaparc (table parc_lots_dev). Chaque action renvoie la réponse, ou undefined en cas d'erreur.
const DevLotsAction = {
    create: (lot) => callWithSuccessToast(ApplicationConf.devLot.lot(), { method: 'POST', body: lot }, 'Erreur lors de la création du lot', 'Lot créé avec succès'),
    update: (lot) => callWithSuccessToast(ApplicationConf.devLot.lot(), { method: 'PUT', body: lot }, 'Erreur lors de la modification du lot', 'Lot modifié avec succès'),
    // Variantes sans toast de succès, pour la synchronisation en lot (un seul message à la fin).
    createQuiet: (lot) => call(ApplicationConf.devLot.lot(), { method: 'POST', body: lot }, `Erreur lors de la création du lot ${lot.nom}`),
    updateQuiet: (lot) => call(ApplicationConf.devLot.lot(), { method: 'PUT', body: lot }, `Erreur lors de la modification du lot ${lot.nom}`),
    remove: (id) => callWithSuccessToast(ApplicationConf.devLot.lotById(id), { method: 'DELETE' }, 'Erreur lors de la suppression du lot', 'Lot supprimé avec succès'),
    assign: (idTicket, idLot) => call(ApplicationConf.devLot.assign(), { method: 'POST', body: { idticket: idTicket, idlot: idLot } }, 'Erreur lors de l\'ajout du ticket au lot'),
    unassign: (idTicket) => call(ApplicationConf.devLot.assignByTicket(idTicket), { method: 'DELETE' }, 'Erreur lors du retrait du ticket du lot'),
}

export default DevLotsAction
